// extracted by mini-css-extract-plugin
module.exports = {"sidebar_wide_tags_container_text":"style_sidebar_wide_tags_container_text__zDWJA"};